/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/cj_credentials_data" endpoint
 */
import { isCjCredentialsResult } from "@dashboardApi/apis/cjCredentials/validators";

import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { cjCredentials } from "./constants";
import type { CjCredentialsParams, CjCredentialsResult } from "./types";

export const getDataTableCjCredentials = reactQueryTableFetcherAdapter(
  cjCredentials,
  (
    signal: AbortSignal,
    { appGroupId, limit, start = 0, sortdir, sortby }: CjCredentialsParams
  ): Promise<CjCredentialsResult> => {
    return fetch(
      `/engagement/${appGroupId}/cj_credentials_data`,
      "GET",
      {
        limit,
        sortby,
        sortdir,
        start,
      },
      { signal }
    );
  },
  isCjCredentialsResult
);
